export default __webpack_public_path__ + "static/media/TransitionFitsImg.c2ce402c.jpg";